import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, removeAuthToken } from '../../../../Config/api';

export const useLogout = () => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleLogout = async () => {
        setIsLoggingOut(true);

        try {
            await logout();
        } catch (error) {
            console.error('Logout API call failed:', error);
        } finally {
            removeAuthToken();
            localStorage.removeItem('user');
            setIsLoggingOut(false);
            navigate('/login', { replace: true });
        }
    };

    return {
        handleLogout,
        isLoggingOut
    };
};